import React from "react";

const Account = () => {
  return (
    <div className="privacy-container">
      {/* Header */}
      <div className="privacy-header">
        <h1>Account Deletion</h1>
      </div>

      {/* Content */}
      <div className="privacy-content">
        <h5>Account Deletion - Pharma Tuition App</h5>

        <p>
          If you want to delete your account or remove your personal data,
          you can request deletion by contacting us through the details below.
        </p>

        <h3>1. How to Request Deletion</h3>
        <p>
          You can request account deletion by emailing or calling us. Please
          include your registered details so we can identify your account.
        </p>

        <h3>2. What Happens After Request</h3>
        <ul>
          <li>Your account will be permanently deleted</li>
          <li>Your personal data will be removed from our system</li>
          <li>This action cannot be undone</li>
        </ul>

        <h3>3. Processing Time</h3>
        <p>
          Account deletion requests are processed within 3–7 working days.
        </p>

        <h3>4. Contact Us</h3>
        <p>For account deletion requests, contact us at:</p>

        <p>
          📧 Email:{" "}
          <a href="mailto:info@pharmatuition.in">
            info@pharmatuition.in
          </a>
        </p>

        <p>
          📞 Call:{" "}
          <a href="tel:+9199741333919">
            +91 99741 33919
          </a>
        </p>
      </div>
    </div>
  );
};

export default Account;